import pMap from 'p-map';
import { destroy } from '../lib/api';

export function remove(growerId, aaids) {
  return pMap(
    aaids,
    (aaid) => destroy(`/growers/${growerId}/productivity/${aaid}`),
    { concurrency: 4 },
  );
}

export function removeNitrogenLoss(growerId, aaids) {
  return pMap(
    aaids,
    (aaid) => destroy(`/growers/${growerId}/nitrogen-loss/${aaid}`),
    { concurrency: 4 },
  );
}
